(function() {
  const drawerSelector = '[data-product-contact-drawer]';
  const closeSelector = '[data-product-contact-close]';
  const whatsappSelector = '[data-product-contact-whatsapp]';
  const optionsSelector = '[data-product-contact-options]';
  const showFormSelector = '[data-product-contact-show-form]';
  const backSelector = '[data-product-contact-back]';
  const formSelector = '.hdt-product-contact-drawer__form';
  const responseSelector = '[data-product-contact-response]';
  const variantEvents = ['variant:update', 'variant:change', 'variant:changed', 'variant:selected'];
  const contactViewTransitions = new WeakMap();
  const contactCloseTimers = new WeakMap();
  const scrollLockedDrawers = new Set();
  let pageScrollPosition = null;
  const contactViewAnimationClasses = [
    'hdt-contact-view--exit-forward',
    'hdt-contact-view--enter-forward',
    'hdt-contact-view--exit-backward',
    'hdt-contact-view--enter-backward'
  ];
  const contactViewPhaseDuration = 110;
  const cartItemSeparator = '[[CONTACT_ITEM]]';
  const cartDetailSeparator = '[[CONTACT_DETAIL]]';
  let currentVariantId = null;
  let currentVariant = null;

  const resolveUrl = (url, origin) => {
    if (!url) {
      return window.location.href;
    }

    try {
      return new URL(url, origin || window.location.origin).toString();
    } catch (error) {
      return window.location.href;
    }
  };

  const buildVariantUrl = (baseUrl, origin, variantId) => {
    if (!baseUrl) {
      return window.location.href;
    }

    try {
      const resolved = new URL(baseUrl, origin || window.location.origin);
      if (variantId) {
        resolved.searchParams.set('variant', variantId);
      }
      return resolved.toString();
    } catch (error) {
      return window.location.href;
    }
  };

  const buildWishlistUrl = (fallbackUrl) => {
    try {
      const resolved = new URL(fallbackUrl || window.location.href, window.location.origin);
      resolved.search = '';
      resolved.searchParams.set('view', 'wishlist');
      return resolved.toString();
    } catch (error) {
      return resolveUrl('/search/?view=wishlist');
    }
  };

  const getProductQuantity = () => {
    const quantityInput = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    return quantityInput && quantityInput.value ? quantityInput.value : '1';
  };

  const setFieldValue = (drawer, selector, value) => {
    const field = drawer.querySelector(selector);
    if (field) {
      field.value = value || '';
    }
  };

  const datasetValue = (drawer, key, fallback) => drawer.dataset[key] || fallback;

  const appendLine = (lines, label, value) => {
    if (value) {
      lines.push(`${label}: ${value}`);
    }
  };

  const formatCartContext = (cartContext) => {
    const lines = [];
    const items = cartContext.split(cartItemSeparator).map((item) => item.trim()).filter(Boolean);

    items.forEach((item, index) => {
      const parts = item.split(cartDetailSeparator).map((part) => part.trim()).filter(Boolean);
      if (!parts.length) return;
      lines.push(parts[0]);
      parts.slice(1).forEach((part) => lines.push(`   ${part}`));
      if (index < items.length - 1) lines.push('');
    });

    return lines;
  };

  const isWishlistPage = (pageType) => {
    if (pageType === 'wishlist') {
      return true;
    }

    try {
      if (new URL(window.location.href).searchParams.get('view') === 'wishlist') {
        return true;
      }
    } catch (error) {
      return false;
    }

    return Boolean(document.querySelector('.hdt-main-wishlist'));
  };

  const getWishlistItems = (origin) => {
    const items = [];
    const seen = new Set();
    document.querySelectorAll('.hdt-main-wishlist hdt-card-product').forEach((card) => {
      const productTitle = card.dataset.wishlistProductTitle || card.querySelector('.hdt-card-product__title')?.textContent?.trim() || '';
      const variantTitle = card.dataset.wishlistVariantTitle || card.querySelector('hdt-wishlist')?.dataset.variantTitle || '';
      const sku = card.dataset.wishlistVariantSku || card.querySelector('hdt-wishlist')?.dataset.variantSku || '';
      const variantId = card.dataset.wishlistVariantId || card.querySelector('hdt-wishlist')?.dataset.variantId || '';
      const url = card.dataset.wishlistProductUrl || card.querySelector('[data-pr-url]')?.getAttribute('href') || '';
      const key = `${productTitle}|${variantId || variantTitle}|${sku}|${url}`;

      if (!productTitle || seen.has(key)) {
        return;
      }

      seen.add(key);
      items.push({
        productTitle,
        variantTitle,
        sku,
        url: resolveUrl(url, origin)
      });
    });
    return items;
  };

  const buildContext = (drawer, variantId, variant) => {
    const rawPageType = drawer.dataset.pageType || '';
    const wishlistPage = isWishlistPage(rawPageType);
    const pageType = wishlistPage ? 'wishlist' : rawPageType;
    const pageTitle = wishlistPage
      ? (document.querySelector('.hdt-wishlist-page__title')?.textContent?.trim() || drawer.dataset.pageTitle || document.title)
      : (drawer.dataset.pageTitle || document.title);
    const productTitle = drawer.dataset.productTitle || '';
    const productUrl = drawer.dataset.productUrl || drawer.dataset.pageUrl || window.location.href;
    const origin = drawer.dataset.shopUrl || window.location.origin;
    const fullUrl = wishlistPage ? buildWishlistUrl(drawer.dataset.pageUrl) : (productTitle ? buildVariantUrl(productUrl, origin, variantId) : (drawer.dataset.pageUrl || window.location.href));
    const variantTitle = variant?.title || drawer.dataset.selectedVariantTitle || '';
    const sku = variant?.sku || drawer.dataset.selectedSku || '';
    const country = drawer.dataset.countryName || drawer.dataset.countryCode || '';
    const cartContext = drawer.dataset.cartContext || '';
    const labels = {
      product: datasetValue(drawer, 'labelProduct', 'Product'),
      collection: datasetValue(drawer, 'labelCollection', 'Collection'),
      wishlist: datasetValue(drawer, 'labelWishlist', 'Wishlist'),
      finish: datasetValue(drawer, 'labelFinish', 'Finish'),
      reference: datasetValue(drawer, 'labelReference', 'Reference'),
      quantity: datasetValue(drawer, 'labelQuantity', 'Quantity'),
      country: datasetValue(drawer, 'labelCountry', 'Country'),
      link: datasetValue(drawer, 'labelLink', 'Link'),
      page: datasetValue(drawer, 'labelPage', 'Page'),
      cart: datasetValue(drawer, 'labelCart', 'Cart')
    };
    const lines = [];
    let cartContents = null;

    if (productTitle) {
      lines.push(datasetValue(drawer, 'messageIntroProduct', drawer.dataset.messageIntro || 'I would like more information about this product:'));
      appendLine(lines, labels.product, productTitle);
      if (variantTitle && variantTitle !== 'Default Title') {
        appendLine(lines, labels.finish, variantTitle);
      }
      if (sku) {
        appendLine(lines, labels.reference, sku);
      }
      appendLine(lines, labels.quantity, getProductQuantity());
      appendLine(lines, labels.country, country);
      appendLine(lines, labels.link, fullUrl);
    } else if (pageType === 'wishlist') {
      const wishlistItems = getWishlistItems(origin);
      lines.push(datasetValue(drawer, 'messageIntroWishlist', drawer.dataset.messageIntro || 'I would like more information about my wishlist:'));
      if (wishlistItems.length) {
        lines.push(`${labels.wishlist}:`);
        wishlistItems.forEach((item, index) => {
          const itemParts = [`${index + 1}. ${item.productTitle}`];
          if (item.variantTitle && item.variantTitle !== 'Default Title') {
            itemParts.push(`${labels.finish}: ${item.variantTitle}`);
          }
          if (item.sku) {
            itemParts.push(`${labels.reference}: ${item.sku}`);
          }
          if (item.url) {
            itemParts.push(`${labels.link}: ${item.url}`);
          }
          lines.push(itemParts.join(' | '));
        });
      } else if (pageTitle) {
        appendLine(lines, labels.wishlist, pageTitle);
      }
      appendLine(lines, labels.country, country);
      appendLine(lines, labels.link, fullUrl);
    } else if (pageType === 'collection') {
      lines.push(datasetValue(drawer, 'messageIntroCollection', 'I would like more information about this collection:'));
      appendLine(lines, labels.collection, pageTitle);
      appendLine(lines, labels.country, country);
      appendLine(lines, labels.link, fullUrl);
    } else if (pageType === 'request_quote' || pageType === 'cart') {
      lines.push(datasetValue(drawer, 'messageIntroCart', 'I would like more information about my cart:'));
      const cartLines = formatCartContext(cartContext);
      if (cartLines.length) {
        lines.push('', `${labels.cart}:`, '', ...cartLines, '');
      }
      appendLine(lines, labels.country, country);
      appendLine(lines, labels.page, fullUrl);
      cartContents = cartLines.join('\n');
    } else {
      lines.push(datasetValue(drawer, 'messageIntroPage', drawer.dataset.messageIntro || 'I would like more information about this page:'));
      if (pageTitle) {
        lines.push(pageTitle);
      }
      appendLine(lines, labels.country, country);
      appendLine(lines, labels.link, fullUrl);
    }

    return {
      context: lines.join('\n'),
      pageUrl: fullUrl,
      pageType,
      productTitle,
      variantTitle,
      sku,
      cartContents
    };
  };

  const updateContactDrawer = (drawer, variantId, variant) => {
    const data = buildContext(drawer, variantId, variant);
    setFieldValue(drawer, '[data-product-contact-context]', data.context);
    setFieldValue(drawer, '[data-product-contact-page-type]', data.pageType);
    setFieldValue(drawer, '[data-product-contact-page-url]', data.pageUrl);
    setFieldValue(drawer, '[data-product-contact-product]', data.productTitle);
    setFieldValue(drawer, '[data-product-contact-variant]', data.variantTitle);
    setFieldValue(drawer, '[data-product-contact-sku]', data.sku);
    if (data.cartContents !== null) {
      setFieldValue(drawer, '[data-product-contact-cart-contents]', data.cartContents);
    }

    const whatsapp = drawer.querySelector(whatsappSelector);
    if (whatsapp) {
      const phone = whatsapp.dataset.whatsappPhone || '390308971379';
      whatsapp.href = `https://wa.me/${encodeURIComponent(phone)}?text=${encodeURIComponent(data.context)}`;
    }
  };

  const updateAllContactDrawers = () => {
    document.querySelectorAll(drawerSelector).forEach((drawer) => {
      updateContactDrawer(drawer, currentVariantId, currentVariant);
    });
  };

  const clearContactViewAnimations = (...views) => {
    views.filter(Boolean).forEach((view) => {
      view.classList.remove(...contactViewAnimationClasses);
    });
  };

  const focusContactView = (viewRoot, view) => {
    const focusSelector = view === 'form'
      ? 'input:not([type="hidden"]):not([hidden]), textarea:not([hidden])'
      : 'button, a';
    const firstField = viewRoot?.querySelector(focusSelector);
    if (firstField) {
      firstField.focus();
    }
  };

  const waitForContactViewAnimation = (viewRoot) => new Promise((resolve) => {
    let complete = false;
    const finish = () => {
      if (complete) return;
      complete = true;
      viewRoot.removeEventListener('animationend', finish);
      window.clearTimeout(timeoutId);
      resolve();
    };
    const timeoutId = window.setTimeout(finish, contactViewPhaseDuration + 80);
    viewRoot.addEventListener('animationend', finish, { once: true });
  });

  const animateContactView = async (drawer, options, form, view, focusForm) => {
    const incoming = view === 'form' ? form : options;
    const outgoing = view === 'form' ? options : form;
    const direction = view === 'form' ? 'forward' : 'backward';
    const transitionToken = Symbol(view);

    contactViewTransitions.set(drawer, transitionToken);
    clearContactViewAnimations(options, form);
    drawer.dataset.contactView = view;

    if (outgoing && !outgoing.hidden) {
      outgoing.classList.add(`hdt-contact-view--exit-${direction}`);
      await waitForContactViewAnimation(outgoing);
      if (contactViewTransitions.get(drawer) !== transitionToken) return;
      outgoing.classList.remove(`hdt-contact-view--exit-${direction}`);
      outgoing.hidden = true;
    }

    if (!incoming) return;
    incoming.hidden = false;
    incoming.classList.add(`hdt-contact-view--enter-${direction}`);
    await waitForContactViewAnimation(incoming);
    if (contactViewTransitions.get(drawer) !== transitionToken) return;

    incoming.classList.remove(`hdt-contact-view--enter-${direction}`);
    if (outgoing) outgoing.hidden = true;
    contactViewTransitions.delete(drawer);

    if (focusForm) {
      focusContactView(view === 'form' ? form : options, view);
    }
  };

  const setContactView = (drawer, view, focusForm = false, animateView = false) => {
    const options = drawer.querySelector(optionsSelector);
    const form = drawer.querySelector(formSelector);
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (animateView && !reduceMotion && options && form && drawer.dataset.contactView !== view) {
      animateContactView(drawer, options, form, view, focusForm);
      return;
    }

    contactViewTransitions.delete(drawer);
    clearContactViewAnimations(options, form);

    if (options) {
      options.hidden = view !== 'options';
    }
    if (form) {
      form.hidden = view !== 'form';
    }

    drawer.dataset.contactView = view;

    if (focusForm) {
      focusContactView(view === 'form' ? form : options, view);
    }
  };

  const hasFormResponse = (drawer) => Boolean(drawer.querySelector(responseSelector));

  const resetContactView = (drawer) => {
    setContactView(drawer, hasFormResponse(drawer) ? 'form' : 'options');
  };

  const lockContactScroll = (drawer) => {
    scrollLockedDrawers.add(drawer);
    if (pageScrollPosition) return;
    pageScrollPosition = { left: window.scrollX, top: window.scrollY };
    const root = document.documentElement;
    root.style.setProperty('--hdt-contact-scroll-top', `${-pageScrollPosition.top}px`);
    root.style.setProperty('--hdt-contact-scroll-left', `${-pageScrollPosition.left}px`);
    root.classList.add('hdt-contact-scroll-locked');
  };

  const unlockContactScroll = (drawer) => {
    scrollLockedDrawers.delete(drawer);
    if (scrollLockedDrawers.size || !pageScrollPosition) return;
    const position = pageScrollPosition;
    pageScrollPosition = null;
    const root = document.documentElement;
    root.classList.remove('hdt-contact-scroll-locked');
    root.style.removeProperty('--hdt-contact-scroll-top');
    root.style.removeProperty('--hdt-contact-scroll-left');
    window.scrollTo({ ...position, behavior: 'instant' });
  };

  const openDrawer = (drawer) => {
    window.clearTimeout(contactCloseTimers.get(drawer));
    contactCloseTimers.delete(drawer);
    drawer.classList.remove('is-closing');
    lockContactScroll(drawer);
    resetContactView(drawer);
    window.requestAnimationFrame(() => {
      if (!drawer.open) return;
      drawer.classList.add('is-active');
      document.documentElement.classList.add('hdt-modal-opened');
    });
  };

  const closeDrawer = (drawer) => {
    window.clearTimeout(contactCloseTimers.get(drawer));
    drawer.classList.remove('is-active');
    drawer.classList.add('is-closing');
    contactCloseTimers.set(drawer, window.setTimeout(() => {
      drawer.open = false;
      contactCloseTimers.delete(drawer);
      drawer.classList.remove('is-closing');
      resetContactView(drawer);
      document.documentElement.classList.remove('hdt-modal-opened');
      unlockContactScroll(drawer);
    }, 280));
  };

  document.addEventListener('toggle', (event) => {
    // Autofill popovers inside the form also emit toggle; only handle the drawer itself.
    const drawer = event.target.matches?.(drawerSelector) ? event.target : null;
    if (!drawer) {
      return;
    }

    if (drawer.open) {
      updateContactDrawer(drawer, currentVariantId, currentVariant);
      openDrawer(drawer);
    } else {
      window.clearTimeout(contactCloseTimers.get(drawer));
      contactCloseTimers.delete(drawer);
      drawer.classList.remove('is-active', 'is-closing');
      document.documentElement.classList.remove('hdt-modal-opened');
      unlockContactScroll(drawer);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const showFormButton = event.target.closest(showFormSelector);
    if (showFormButton) {
      const drawer = showFormButton.closest(drawerSelector);
      if (drawer) {
        event.preventDefault();
        setContactView(drawer, 'form', true, true);
      }
      return;
    }

    const backButton = event.target.closest(backSelector);
    if (backButton) {
      const drawer = backButton.closest(drawerSelector);
      if (drawer) {
        event.preventDefault();
        setContactView(drawer, 'options', true, true);
      }
      return;
    }

    const closeButton = event.target.closest(closeSelector);
    if (!closeButton) {
      return;
    }

    const drawer = closeButton.closest(drawerSelector);
    if (!drawer) {
      return;
    }

    event.preventDefault();
    closeDrawer(drawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll(`${drawerSelector}[open]`).forEach(closeDrawer);
  });

  variantEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const variantId = event?.detail?.variant?.id || event?.detail?.variantId;
      if (!variantId) {
        return;
      }
      currentVariantId = variantId;
      currentVariant = event?.detail?.variant || null;
      updateAllContactDrawers();
    });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('form[action*="/cart/add"] [name="quantity"]')) {
      updateAllContactDrawers();
    }
  });

  document.addEventListener('theme4:wishlist:hydrated', updateAllContactDrawers);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllContactDrawers);
  } else {
    updateAllContactDrawers();
  }
})();
